module.exports = __webpack_public_path__ + "img/classify-item3-active.47dba18a.png";